/* ryfix-global: audit fixes, workstream global (28 Sep 2026). Deferred, small, no layout work on load. */
(function () {
  'use strict';
  var html = document.documentElement;

  /* 1. --ry-bottom-bar-h: the phone bottom bar's real height (CSS gives a 61px fallback). Floating UI (chat) clears it. */
  var bar = document.querySelector('.m-mobile-sticky-bar');
  function setBar() {
    var h = 0;
    if (bar) { var cs = getComputedStyle(bar); if (cs.display !== 'none' && cs.visibility !== 'hidden') h = bar.offsetHeight; }
    html.style.setProperty('--ry-bottom-bar-h', h + 'px');
  }
  if (bar) {
    setBar();
    if (window.ResizeObserver) new ResizeObserver(setBar).observe(bar);
    window.matchMedia('(max-width: 767px)').addEventListener('change', setBar);
  }

  /* 2. html.ry-overlay-open while any dialog / modal is showing, so the chat launcher steps aside
        (cart drawer, search popup and Minimog modals are already covered by html.prevent-scroll). */
  var OPEN = 'dialog[open], [aria-modal="true"]:not([hidden]), .m-cart-drawer.m-cart-drawer--active, m-cart-drawer[open], .m-open-modal, #m-menu-drawer.open, .m-search-popup[open], m-search-popup[open]';
  var raf = 0;
  function check() {
    raf = 0;
    var on = false, list = document.querySelectorAll(OPEN);
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.tagName === 'SHOPIFY-CHAT' || el.closest('shopify-chat')) continue;
      var r = el.getBoundingClientRect(), cs = getComputedStyle(el);
      if (r.width > 0 && r.height > 0 && cs.visibility !== 'hidden' && cs.display !== 'none' && +cs.opacity > 0.05) { on = true; break; }
    }
    html.classList.toggle('ry-overlay-open', on);
  }
  function queue() { if (!raf) raf = requestAnimationFrame(check); }
  new MutationObserver(queue).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'class', 'hidden', 'aria-modal'] });
  queue();

  /* 3. Homepage carousel (The Edit): arrows scroll one view, hide when nothing further; swipe uses native scroll-snap. */
  document.querySelectorAll('[data-ryh-rail]').forEach(function (wrap) {
    var rail = wrap.querySelector('.ryh-rail'); if (!rail) return;
    var prev = wrap.querySelector('[data-ryh-prev]'), next = wrap.querySelector('[data-ryh-next]'), nav = wrap.querySelector('.ryh-rail__nav');
    function step(dir) {
      var li = rail.querySelector('li'); var w = li ? li.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 0) : rail.clientWidth;
      var n = Math.max(1, Math.floor((rail.clientWidth + 1) / w));
      rail.scrollBy({ left: dir * n * w, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (nav) nav.style.visibility = max <= 0 ? "hidden" : "";
      var f = document.activeElement;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
      if (f && f.disabled) { var o = f === prev ? next : prev; if (o && !o.disabled) o.focus(); }
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  });
  /* 4. /discount/CODE lands on the homepage silently: confirm once per session that the code is saved (Shopify's discount_code cookie). */
  try {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (m && !sessionStorage.getItem('ry-dc-' + m[1])) {
      sessionStorage.setItem('ry-dc-' + m[1], '1');
      var code = decodeURIComponent(m[1]).replace(/[^\w-]/g, '').slice(0, 30);
      var n = document.createElement('div'); n.className = 'ry-toast'; n.setAttribute('role', 'status');
      n.innerHTML = '<p>Code <strong></strong> is saved. It is applied at checkout if your order qualifies.</p><button type="button" class="ry-toast__x" aria-label="Dismiss">\u00d7</button>';
      n.querySelector('strong').textContent = code;
      n.querySelector('button').addEventListener('click', function () { n.remove(); });
      document.body.appendChild(n); setTimeout(function () { if (n.isConnected) n.remove(); }, 9000);
    }
  } catch (e) {}
})();
